module.exports = __webpack_public_path__ + "img/introduction_media_01.b145c35e.jpg";